import { BASE_SELECTOR } from "../../crossconcern/utilities/properties/selector.property";
import { Component } from "@angular/core";
import { AppComponent } from "../app.component";
import { Router, NavigationExtras } from "@angular/router";
import { AlertUtils } from "../../crossconcern/utilities/utils/alert.utils";
import { Location } from "@angular/common";
import { ProductModel } from "../../datastore/entities/product.model";
import { LANG_CODE_EN, LANG_CODE_FR, LANG_CODE_IT } from "../../crossconcern/utilities/properties/base.property";

@Component({
    selector: BASE_SELECTOR,
    template: ""
})
export class BaseComponent {
    protected routeByNamePromise: Promise<{[key: string]: string}> = null;

    constructor(protected appComponent: AppComponent, protected router: Router, protected alertUtils: AlertUtils,
        protected location: Location) {
        this.routeByNamePromise = import("app/app.routes")
            .then(({ ROUTE_PATH_BY_NAME }) => {
                return ROUTE_PATH_BY_NAME;
            });
    }

    public goToRoute(route: string, queryParams?: unknown) {
        this.router.navigate(
            [
                route
            ],
            {
                queryParams
            });
    }

    public goToRouteByName(routeName: string, urlParams: {[key: string]: string} = {}, queryParams?: unknown) {
        return this.goToRouteByNameWithExtras(routeName, urlParams, {
            queryParams
        });
    }

    public goToRouteWithExtras(route: string, extras: NavigationExtras) {
        this.router.navigate([
            route
        ], extras);
    }

    public goToRouteByNameWithExtras(routeName: string, urlParams: {[key: string]: string}, extras: NavigationExtras) {
        return this.routeByNamePromise
            .then((routeByName) => {
                return this.router.navigate(
                    [
                        this.interpolateUrl(routeByName[routeName], urlParams)
                    ],
                    extras
                );
            });
    }

    public goToNewTabByName(routeName: string) {
        return this.routeByNamePromise
            .then((routeByName) => {
                window.open(routeByName[routeName], "_blank");
            });
    }

    public goBackRoute(): void {
        this.location.back();
    }

    public interpolateUrl(routerPath: string, params: {[key: string]: string}) {
        return routerPath.replace(
            new RegExp("/:([a-zA-Z0-9]+)", "g"),
            (_, paramName) => {
                return "/" + (params[paramName] ? params[paramName] : "");
            }
        );
    }

    public getProductName(productModel: ProductModel, language: string) {
        switch (language) {
            case LANG_CODE_IT:
                return productModel.varDex;
            case LANG_CODE_EN:
                return productModel.varIng !== undefined && productModel.varIng !== null
                && productModel.varIng.length !== 0 ? productModel.varIng : productModel.varDex;
            case LANG_CODE_FR:
                return productModel.varFra !== undefined && productModel.varFra !== null
                && productModel.varFra.length !== 0 ? productModel.varFra : productModel.varDex;
        }
    }
}
